import zh from './zh';
export default {
    ...zh,
    frame: {
        ...zh.frame,
        'desc_title': '咕咕咕咕',
        tabbar: {
            ...zh.frame.tabbar,
            'index': '咕咕',
            'about': '咕咕',
            'trends': '咕咕'
        },
        open: {
            ...zh.frame.open,
            'qqgroup': '咕 咕咕',
            'liveroom': '咕咕咕咕',
            'biligroup': '咕咕 咕咕'
        }
    },
    lang: 'gu',
    app: {
        ...zh.app,
        'title': '咕咕咕咕 - 咕咕咕咕咕咕',
        "desc": [
            "咕咕咕咕咕咕咕咕咕咕？咕咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕咕。",
            "咕咕咕咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕？咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕。",
            "咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕咕咕咕咕咕，咕咕咕咕咕咕咕咕咕咕咕咕咕！"
        ]
    },
}